import { RecordSource, RelayFeatureFlags, Store } from 'relay-runtime';
import LiveResolverStore

// @ts-ignore
from 'relay-runtime/lib/store/experimental-live-resolvers/LiveResolverStore';
import { fg } from '@atlaskit/platform-feature-flags';
import RelayDataID from '@atlassian/relay-data-id';
import RelayMissingFieldHandlers from '@atlassian/relay-missing-field-handlers';
import { network as defaultNetwork } from '@atlassian/relay-network';
import RelayScheduler from '@atlassian/relay-scheduler';
var createStore = function createStore(source, options) {
  if (fg('platform.jira-frontend.enable-relay-resolvers')) {
    RelayFeatureFlags.ENABLE_RELAY_RESOLVERS = true;
    return new LiveResolverStore(source, options);
  }
  return new Store(source, options);
};
export var getDefaultRelayEnvironmentConfig = function getDefaultRelayEnvironmentConfig(_ref) {
  var log = _ref.log,
    requiredFieldLogger = _ref.requiredFieldLogger,
    network = _ref.network;
  return {
    configName: 'Atlassian Graphql Gateway',
    network: network || defaultNetwork,
    store: createStore(new RecordSource(), {
      log: log !== null && log !== void 0 ? log : undefined,
      getDataID: RelayDataID
    }),
    log: log,
    requiredFieldLogger: requiredFieldLogger,
    // Renamed https://github.com/facebook/relay/commit/914794c4ddba6f7c8d2469ecdc5aa42eb112a6bb
    // @ts-expect-error Object literal may only specify known properties, and 'relayFieldLogger' does not exist in type 'EnvironmentConfig'
    relayFieldLogger: requiredFieldLogger,
    getDataID: RelayDataID,
    scheduler: RelayScheduler,
    missingFieldHandlers: RelayMissingFieldHandlers
  };
};